// Игроки по списку id: несуществующие и пустые id (null для «цель — не отряд»
// или ничейный гекс) просто не попадают в результат
export const getPlayersByIds = (players, ids) =>
  (players || []).filter((player) => ids.includes(player.id));
